import React, { useState } from 'react'
import MuiTextField from '@zuto/atoms/src/Mui/TextField/MuiTextField'
import { sanitizeAndFormatGBNumber } from '../../../../../src/components/Questions/utils'

export type MuiCurrencyInputProps = {
  adornmentLabel?: string
  adornmentShown?: boolean
  darkerInput?: boolean
  defaultValue?: string
  disabled?: boolean
  errorText?: string
  helperText?: string
  label: string
  name?: string
  onBlur?: React.FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>
  onChange?: React.ChangeEventHandler<HTMLInputElement>
  onKeyPress?: React.KeyboardEventHandler<HTMLInputElement>
  testId?: string
  value?: string | number
  formatToGBNumber?: boolean
}

const MuiCurrencyInput = (
  {
    adornmentLabel,
    adornmentShown,
    darkerInput,
    defaultValue,
    disabled,
    errorText,
    helperText,
    label,
    onBlur,
    onChange,
    onKeyPress,
    value,
    formatToGBNumber
  }: MuiCurrencyInputProps
) => {
  const [isSelected, setIsSelected] = useState(false)
  const [formattedInput, setFormattedInput] = useState<string>(sanitizeAndFormatGBNumber(value ?? ''))


  const stopNegativeValues = (input: HTMLInputElement) => {
    // Convert the input value to an integer by removing all non-numeric characters
    const valueAsInt = parseInt(input.value.replace(/[^0-9]/g, ''), 10)
    return Math.abs(valueAsInt) >= 0 ? Math.abs(valueAsInt).toString() : ''
  }

  const onChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.currentTarget.value = stopNegativeValues(e.currentTarget)

    setFormattedInput(sanitizeAndFormatGBNumber(e.currentTarget.value))

    if (onChange) {
      onChange(e)
    }
  }

  const onBlurHandler = (e: React.FocusEvent<HTMLInputElement>) => {
    e.currentTarget.value = e.currentTarget.value.replace(/[^0-9]/g, '')
    setIsSelected(false)

    if (onBlur) {
      onBlur(e)
    }
  }

  const onKeyPressHandler = (e: React.KeyboardEvent<HTMLInputElement>): void => {
    if (onKeyPress) {
      if (e.code === 'Enter' || e.key === 'Enter') {
        onKeyPress(e)
      }
    }
  }

  const handleIsSelected = () => {
    setIsSelected(true)
  }

  return (
    <MuiTextField
      adornmentLabel={adornmentLabel}
      adornmentShown={adornmentShown}
      darkerInput={darkerInput}
      defaultValue={defaultValue}
      disabled={disabled}
      errorMessage={errorText}
      helperMessage={helperText}
      id="currency-input"
      inputType={formatToGBNumber ? "string" : "number"}
      {...(formatToGBNumber && {inputMode:"numeric"})}
      inputVariant="outlined"
      isSelected={isSelected}
      isSelectedHandler={handleIsSelected}
      label={label}
      name="currency-input"
      onBlurHandler={onBlurHandler}
      onChangeHandler={onChangeHandler}
      onKeyPressHandler={onKeyPressHandler}
      pattern="[0-9]*"
      testId="currency-input"
      value={formatToGBNumber ? formattedInput : value}
    />
  )
}

export default MuiCurrencyInput
